module.exports = __webpack_public_path__ + "static/media/subnav-github.b41366d9.svg";